import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ncfzLoginRequestSchema, type NcfzLoginRequestType } from "@features/auth/model/loginModel";
import { useFetchNcfzLogin } from "@features/auth/hooks/mutations/useNcfzLogin";

export const useNcfzLoginForm = () => {
  const { mutate: fetchNcfzLogin, isPending } = useFetchNcfzLogin();

  const form = useForm<NcfzLoginRequestType>({
    resolver: zodResolver(ncfzLoginRequestSchema),
    defaultValues: {
      secondaryId: "",
      secondaryPassword: "",
    },
  });

  const submitHandler = useCallback(
    (data: NcfzLoginRequestType) => {
      fetchNcfzLogin(data);
    },
    [fetchNcfzLogin],
  );

  return { ...form, handleSubmit: form.handleSubmit(submitHandler), isPending };
};
